//事件处理器，观察者模式
var Event = (function () {
    return {
        $E:function (b) {
            var a = typeof b == "string" ? document.getElementById(b) : b;
            if (a != null) {
                return a
            } else {
            }
            return null
        },
        addEvent: function (obj, eventType, func) {
            var f =this.$E(obj);
            if (f == null) {
                console.log("removeEvent 找不到对象：" + obj);
                return
            }
            if (eventType.indexOf(",") != -1) {
                var arr = eventType.split(",");
                for (var i = 0, len = arr.length; i < len; i++) {
                    var evtype = arr[i];
                    if (evtype == "") return;
                    if (f.attachEvent) {
                        f.attachEvent("on" + evtype, func);
                    } else {
                        f.addEventListener(evtype, func, false);
                    }
                }
                arr = null;
            } else {
                if (f.attachEvent) {
                    f.attachEvent("on" + eventType, func);
                } else {
                    f.addEventListener(eventType, func, false);
                }
            }
        },
        removeEvent: function (obj, eventType, func) {
            var f = this.$E(obj);
            if (f == null) {
                // trace("removeEvent 找不到对象：" + obj);
                return
            }
            if (typeof func != "function") {
                return
            }
            if (typeof eventType == "undefined") {
                return
            }
            if (eventType.indexOf(",") != -1) {
                var arr = eventType.split(",");
                for (var i = 0, len = arr.length; i < len; i++) {
                    var evType = arr[i];
                    if (evType == "") return;
                    if (f.addEventListener) {
                        f.removeEventListener(evType, func, false)
                    } else {
                        if (f.attachEvent) {
                            f.detachEvent("on" + evType, func)
                        }
                    }
                }
                arr = null;
            } else {
                if (f.addEventListener) {
                    f.removeEventListener(eventType, func, false)
                } else {
                    if (f.attachEvent) {
                        f.detachEvent("on" + eventType, func)
                    }
                }
            }
        }
    }
})();
module.exports = Event;